import { Tabs } from "antd";

import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import PageHeader from "@/components/UI/PageHeader";
import StudyDesignSchedule from "./StudyDesignSchedule";

const STUDY_DESIGN_CONSTANTS = {
  wikiLink: "/wiki/guides/exploration-data-studydesign",
  idLink: undefined,
};

export default function StudyDesign() {
  const items = [
    {
      key: "schedule",
      label: "Schedule",
      children: <StudyDesignSchedule />,
    },
    {
      key: "schedule-list",
      label: "Schedule (list)",
      children: (
        <MetadataDashboardTemplate
          type="study_design_soa"
          constants={STUDY_DESIGN_CONSTANTS}
          selectionIdentifierColumn="form_name"
        />
      ),
    },
    {
      key: "items",
      label: "Items",
      children: (
        <MetadataDashboardTemplate
          type="study_design_items"
          constants={STUDY_DESIGN_CONSTANTS}
          selectionIdentifierColumn="item_oid"
        />
      ),
    },
  ];

  return (
    <div className="w-full p-4">
      <div className="flex justify-between mb-4 relative z-20">
        <div className="flex gap-2">
          <PageHeader
            title="Data: Study Design"
            tooltipText="Study design as configured in the source system: schedule of activities (visits and forms) and item-level definitions."
          />
        </div>
      </div>
      <Tabs destroyOnHidden items={items} />
    </div>
  );
}
